/* eslint-disable */
import App from './app';

class Menu extends App {

  constructor() {

    super();

    var self = this;
    this.isOpen = false;
    this._body = $('body');
    this._header = $('#header');
    this._menu = $('#navigation');
    this._mmwidgets = $('.widgetcol');
    this._logo = this._header.find('.navbar-brand');
    this._scrolling = false;
    this._scrollOffset = 15;
    this._hamburger = $('#hamburger');
   // this._btnClose = $('#closenav');
    this.desktopMenuBreakpoint = window.matchMedia('(min-width:1200px)');
    this.largeDesktopBreakpoint = window.matchMedia('(min-width:1400px)');
    this.mobileBreakpoint = window.matchMedia('(max-width:767px)');

    this._headerSpacer = this.$('#hspacer');
    this._useHeaderSpacer = false; // inserito con css

    this.init();

  }

  init(){
    super.init();
    var self = this;

    this._bindResize();
    this._bindScroll();
    //this._bindBootstrapEvents();
    this._bindHamburger();
    //this._bindHoverEvent();

    this._onScroll();

  }

  _bindScroll(){

    let self = this;

    this.$window.scroll( function() {
      self._scrolling = true;
    });

    setInterval( function() {
      if ( self._scrolling ) {
        self._scrolling = false;
        self._onScroll();
      }
    }, 250 );

  }

  _onScroll(){

    if( this.$window.scrollTop() > this._scrollOffset ) {
        this._header.addClass('hdr--scroll');
    } else {
      // ricalcolo anche lo spazio occupato dall'header
      setTimeout(() => this._reloadHeaderSpacer() , 100);
      this._header.removeClass('hdr--scroll');
    }

  }

  _onOpenMenu() {
    this.isOpen = true;
    this._hamburger.addClass('is-active');
    this._body.addClass('mopen');
  }

  _onCloseMenu() {

      this.isOpen = false;
      this._hamburger.removeClass('is-active');
      this._body.removeClass('mopen');

  }

  /*
  _bindHoverEvent() {

    let self = this;


    this._menu.find('> ul > li > a').unbind('hover');

    if( self.largeDesktopBreakpoint.matches ) {

      // workaround: altrimenti non calcola correttamente le width interne
      this._menu.find('> ul > li > a').hover(function () {
        if ( !self.isOpen )
          self._reloadInnerSidebarWidth();
      });

    }

  }*/

  /*_bindBootstrapEvents(){

    let self = this;

    this._menu.on("shown.bs.dropdown", function (event) {
      if( self.desktopMenuBreakpoint.matches ) {
        self._onOpenMenu();
      }
    });

    this._menu.on("hide.bs.dropdown", function (event) {
      if( self.desktopMenuBreakpoint.matches ) {
        self._onCloseMenu();
      }
    });

  }*/

  _bindHamburger(){

    let self = this;

    this._hamburger.click( function (evt) {

      if( ! self.isOpen ) {
        self._onOpenMenu();
      } else {
        self._onCloseMenu();
      }

    });

   /* this._btnClose .click( function (evt) {
      self._onCloseMenu();
    });*/

  }

  _reloadHeaderSpacer() {
    /*if( this._useHeaderSpacer ) {
      this._headerSpacer.height( this._header.outerHeight() );
    }*/
  }

  _onResize(){

    // this._reloadHeaderSpacer();
    // this._bindHoverEvent();

  }

  /*_reloadInnerSidebarWidth(){

    const firstEl = this._menu.find('.nav-link:eq(0)');

    if( this.largeDesktopBreakpoint.matches ) {
      this._mmwidgets.width(this._logo.outerWidth());
    }
    else {
      this._mmwidgets.clearStyles();
    }

  }*/

  /*_onLoaded(){
    setTimeout( () => this._onResize() , 300);
  }*/

}

export default Menu;



// WEBPACK FOOTER //
// ./scripts/classes/menu.js